export default __webpack_public_path__ + "static/media/watch5.29fffcc6.jpg";